import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateDosespotClinicianRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchCreateDosespotClinician } from '../api/createDosespotClinician.js';
import { dosespotClinicianKeys } from './keys.js';

export interface CreateDosespotClinicianVariables {
  data: CreateDosespotClinicianRequestT;
}

export function useCreateDosespotClinicianMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['dosespot-clinician', 'create'],
    mutationFn: async ({ data }: CreateDosespotClinicianVariables) => {
      return await fetchCreateDosespotClinician(data);
    },
    onSuccess: () => {
      // Invalidate both user lists after creating a new clinician
      queryClient.invalidateQueries({ queryKey: dosespotClinicianKeys.usersWithRecords() });
      queryClient.invalidateQueries({ queryKey: dosespotClinicianKeys.usersWithoutRecords() });
    },
  });
}
